import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { Spinner } from './';

class Cargador extends Component {
  renderError() {
    if (this.props.mostrar_error_app === true) { return <><p className="alertasRojas alertasCorto">{ this.props.error_app }</p><br /></>; }

    return null;
  }

  render() {
    const { t } = this.props;

    return (
      <section className="contenedor cajeadoVertical cajeadoHorizontal" style={{ overflowY: 'hidden' }}>
        <header>
          <h1 className="sr-only">{t('cargador.titulo')}</h1>
        </header>

        <article>
          {this.renderError()}

          <Spinner size="Big" />

          <p className="fontBig textoAzulBold margenSuperiorBig textoCentrado" >{t('cargador.textoUno')}</p>
          <p className="fontBig textoAzulBold textoCentrado margenInferiorBig">{t('cargador.textoDos')}</p>
        </article>
      </section>
    );
  }
}

const mapStateToProps = ({ app }) => {
  const { error_app, mostrar_error_app } = app;

  return { error_app, mostrar_error_app };
};

export default compose(
  connect(mapStateToProps, null),
  withTranslation('common')
)(Cargador);
